import { client } from "../../../api/client";

export const fetchAudit = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        return require("./_local/_auditData.json");
    } else {
        try {
            const response = await client.get(process.env.REACT_APP_GATEWAY_URI, "auditapi/audititem");
            return response.data;
        } catch (error) {
            console.error("Error fetching audit:", error);
            return [];
        }
    }
};

export const fetchAuditByFilter = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") {
        if (!!body.userGuid) {
            var dataFile = require("./_local/_auditData.json");
            var newAuditItems = dataFile.auditItems.filter(f => f.userGuid === body.userGuid);
            return {
                auditItems: newAuditItems,
                totalRecords: newAuditItems.length
            }
        }
        else
            return require("./_local/_auditData.json");
    } else {
        try {
            const response = await client.post(process.env.REACT_APP_GATEWAY_URI, "auditapi/audititem/filter", body);
            return response.data;
        } catch (error) {
            console.error("Error fetching audit:", error);
            return [];
        }
    }
};

export const createAudit = async (body) => {
    if (process.env.REACT_APP_USELOCALDATA === "false") {
        try {
            return await client.post(process.env.REACT_APP_GATEWAY_URI, 'auditapi/audititem', body);
        } catch (error) {
            console.error("Error creating audit:", error);
            return [];
        }
    }
};